




import { MdInfoOutline, MdLocationPin, MdStar } from "react-icons/md";
import { Link } from "react-router-dom";
import { FaShareAlt, FaHeart, FaRegHeart, FaUserPlus, FaUserCheck } from "react-icons/fa";
import VerifyCompanyButton from "./VerifyCompanyButton";
import { useMakeRequest } from "../hooks/useMakeRequest";

import { MdCheckCircle, MdCancel } from "react-icons/md";

import axios from "axios";
import { useState } from "react";
import { toast } from "sonner";
import AboutEmployerModal from "./AboutEmployerPage";
import JobDistance from "../Utils/location/JobDistance";

function JobPostJobPage({
  position,
  location,
  companyName,
  industry,
  salary,
  jobType,
  experience,
  duration,
  status,
    employerId,  
    virtualInterview,
  jobId,
  contactMail,
  localGovernment,
  uniqueViewers,
  city,
   aboutUs,          // ← new
  employerType,     // ← new (optional, if available)
  companySize,      // ← new (optional, if available)
  isEmployerVerified,
  // === LIKE & FOLLOW PROPS ===
  initialLikeCount = 0,
  initialFollowCount = 0,
  isLiked: initialIsLiked = false,
  isFollowing: initialIsFollowing = false,
}) {
  const API_URL = process.env.REACT_APP_API_URL;
  const makeRequest = useMakeRequest();

  const [isLiked, setIsLiked] = useState(initialIsLiked);
  const [isFollowing, setIsFollowing] = useState(initialIsFollowing);
  const [likeCount, setLikeCount] = useState(initialLikeCount);
  const [followCount, setFollowCount] = useState(initialFollowCount);
  const [loading, setLoading] = useState(false);
    const [showAboutModal, setShowAboutModal] = useState(false);

  const handleMailCompany = () => {
    window.location.href = `mailto:${contactMail}?subject=${position}`;
  };

  const handleShare = () => {
    if (navigator.share) {
      navigator.share({
        title: `${position} at ${companyName}`,
        text: `Check out this job: ${position} in ${location} (LGA: ${localGovernment}, City: ${city}).`,
        url: window.location.origin + `/job/${jobId}`,
      }).catch((error) => console.error("Error sharing:", error));
    } else {
      navigator.clipboard.writeText(window.location.origin + `/job/${jobId}`);
      toast.success("Link copied to clipboard!");
    }
  };


const handleLike = async () => {
  if (!jobId || loading) return;

  setLoading(true);

  const token = localStorage.getItem("token");
  const endpoint = `${API_URL}job/like/${jobId}`;
console.log(token)
  try {
    const response = await axios.post(
      endpoint,
      {}, // Empty body
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const data = response.data;

    setIsLiked(data.liked);
    setLikeCount((prev) => (data.liked ? prev + 1 : prev - 1));
    toast.success(data.liked ? "Job liked!" : "Job unliked");
  } catch (error) {
    const message =
      error.response?.data?.message || "Failed to like job";
    toast.error(message);
    console.error("Like error:", error);
  } finally {
    setLoading(false);
  }
};

const handleFollow = async () => {
  if (!jobId || loading) return;

  setLoading(true);

  const token = localStorage.getItem("token");
  const endpoint = `${API_URL}job/follow/${jobId}`;

  try {
    const response = await axios.post(
      endpoint,
      {},
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const data = response.data;

    setIsFollowing(data.followed);
    setFollowCount((prev) => (data.followed ? prev + 1 : prev - 1));
    toast.success(data.followed ? "Following job & company!" : "Unfollowed");
  } catch (error) {
    const message =
      error.response?.data?.message || "Failed to follow";
    toast.error(message);
    console.error("Follow error:", error);
  } finally {
    setLoading(false);
  }
};
  

  return (
    <div className="sm:p-5 p-4 bg-white shadow-md text-sm border border-gray-200 rounded-lg mb-6 relative overflow-hidden transition-transform transform hover:scale-105">
      <div className="bg-orange-500 absolute -top-[14px] -left-[65px] w-[200px] h-[100px] rotate-[314.5deg]"></div>
      <div className="relative z-10">
     {virtualInterview ? (
  <MdCheckCircle className="text-green-600 inline" title="Virtual interview available" />
) : (
  <MdCancel className="text-red-500 inline" title="No virtual interview" />
)}
        <div className="z-10 absolute -top-2 right-2 bg-yellow-400 p-2 rounded-full">
          <MdStar className="relative text-white w-5 h-5 z-10" />
        </div>

        <div className="mb-4">
          <h1 className="text-2xl relative z-30 font-bold text-gray-600 capitalize">
            {position}
          </h1>
          <h2 className="text-xl capitalize text-gray-600">{companyName}</h2>
        </div>

        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center  font-bold text-gray-600">
            <MdLocationPin className="text-orange-500 mr-2" />
            <span>{location} (LGA: {localGovernment}, City: {city})</span>
          </div>
                  <div className="mb-4">
  <JobDistance state={location} localGovernment={localGovernment}  />
</div>
          <div className="text-gray-600">
            <span>Salary: {salary}</span>
          </div>

        </div>



        <div className="text-gray-600 mb-4 flex items-center justify-between flex-col sm:flex-row">
          <span className="font-semibold">Job Type: {jobType}</span>
          <span className="font-semibold">Industry: {industry}</span>
          {contactMail ? (
            <button onClick={handleMailCompany}>
              Contact:{" "}
              <span className="hover:text-orange-400 underline">{contactMail}</span>
            </button>
          ) : null}
        </div>

        <div className="flex items-center justify-between border-t pt-4 text-gray-600">
          <div>
            <p>Experience Level: {experience}</p>
            <p>Valid Till: {new Date(duration).toLocaleDateString()}</p>
          </div>

          <div className="flex flex-wrap items-center gap-2 sm:gap-3">
            {/* APPLY BUTTON */}
            <Link
              to={`/job/${jobId}`}
              className="bg-orange-500 text-white rounded-2xl p-2 font-semibold hover:underline"
            >
              {status}
            </Link>
   {/* ABOUT EMPLOYER BUTTON */}
       <Link
  to={`/company/${employerId}`}
  className="flex items-center gap-1 px-3 py-1 rounded-full text-sm font-medium bg-slate-100 text-slate-700 hover:bg-slate-200 transition-all"
  title="About this employer"
>
  <MdInfoOutline size={16} />
  <span>About Employer</span>
</Link>
            {/* SHARE BUTTON */}
            <button
              onClick={handleShare}
              className="text-blue-500 hover:text-blue-700 transition"
              title="Share this job"
            >
              <FaShareAlt size={18} />
            </button>

            {/* LIKE BUTTON */}
            <button
              onClick={handleLike}
              disabled={loading}
              className={`flex items-center gap-1 px-3 py-1 rounded-full text-sm font-medium transition-all ${
                isLiked
                  ? "bg-red-500 text-white hover:bg-red-600"
                  : "bg-gray-200 text-gray-700 hover:bg-gray-300"
              }`}
              title={isLiked ? "Unlike" : "Like"}
            >
              {isLiked ? <FaHeart size={16} /> : <FaRegHeart size={16} />}
              <span>{likeCount}</span>
            </button>

            {/* FOLLOW BUTTON */}
            <button
              onClick={handleFollow}
              disabled={loading}
              className={`flex items-center gap-1 px-3 py-1 rounded-full text-sm font-medium transition-all ${
                isFollowing
                  ? "bg-blue-600 text-white hover:bg-blue-700"
                  : "bg-gray-200 text-gray-700 hover:bg-gray-300"
              }`}
              title={isFollowing ? "Unfollow" : "Follow"}
            >
              {isFollowing ? <FaUserCheck size={16} /> : <FaUserPlus size={16} />}
              <span>{followCount}</span>
            </button>

            <div className="flex items-center gap-2 text-gray-600">
  <span>👀 {uniqueViewers?.length || 0}</span>
  <span>views</span>
</div>

            {/* VERIFY COMPANY */}
            <VerifyCompanyButton
              companyName={companyName}
              location={location}
              localGovernment={localGovernment}
              city={city}
            />
          </div>
        </div>
      </div>


    
    </div>
  );
}

export default JobPostJobPage;























































